import { AbstractModel } from './abstract-model';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class RideRequestLocation extends AbstractModel {
  @autoserialize
  locationId: number;

  @autoserialize
  sublocationId: number;

  @autoserialize
  display: string;

  @autoserialize
  sublocationName: string;

  @autoserialize
  sublocationDescription: string;

  @autoserialize
  latitude: number;

  @autoserialize
  longitude: number;

  @autoserialize
  requiresReview: boolean;

  @autoserialize
  isReviewed: boolean;

  @autoserialize
  reviewedByUserId: number;
}
